import moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'calculateAge',
})
export class CalculateAgePipe implements PipeTransform {
    constructor() {
    }

    transform(value: string) {
        if (value) {
            const dateValue = moment(value) as moment.Moment;

            return Math.floor(moment.duration(moment().diff(moment(dateValue))).asYears());
        }
        return value || '';
    }
}
